exports = module.exports = require("../../../../../../../node_modules/.pnpm/css-loader@0.28.7/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".StarRating .fa-star {\r\n  color: gold;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.7/node_modules/css-loader!./src/scenes/MapContainer/components/PopupContainer/components/StarRating/StarRating.css
// module id = 878
// module chunks = 0